import { makeAutoObservable } from 'mobx';

export interface IBrowserUrlModel {
	readonly search: string;
	readonly searchParams: URLSearchParams;
	readonly setSearch: (search: string) => void;
}

export class BrowserUrlModel implements IBrowserUrlModel {
	search: string;

	private constructor() {
		this.search = globalThis.location?.search ?? '';

		makeAutoObservable(this);
	}

	static readonly create = (): BrowserUrlModel => new BrowserUrlModel();

	readonly setSearch = (search: string): void => {
		// Why string and not URLSearchParams? or perhaps support both?
		this.search = search;
	};

	get searchParams(): URLSearchParams {
		return new URLSearchParams(this.search);
	}
}

let maybeBrowserUrlModel: BrowserUrlModel | null = null;

export function getOrCreateBrowserUrlModel(): BrowserUrlModel {
	maybeBrowserUrlModel ??= BrowserUrlModel.create();
	return maybeBrowserUrlModel;
}
